import clsx from 'clsx';
import { fgTone } from '../../utils/style/tone.js';
import type { TextStyleOptions } from './types.js';

/** Returns a string of classNames that apply the specified text style. */
export function textStyle({ variant, fontStyle, alignment, textDecoration, tone }: TextStyleOptions) {
  return clsx(
    'cim-text',
    {
      [`cim-text-variant-${variant}`]: variant,
      [`cim-text-fs-${fontStyle}`]: fontStyle,
      [`cim-text-alignment-${alignment}`]: alignment,
      [`cim-text-decoration-${textDecoration}`]: textDecoration,
    },
    tone && fgTone(tone),
  );
}
